import React from "react";

export default function MedEaseMark({ size = 40, className = "" }) {
  return (
    <svg
      className={`medease-mark ${className}`}
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      aria-hidden="true"
    >
      <rect x="1" y="1" width="46" height="46" rx="10" stroke="currentColor" strokeWidth="1.2" opacity="0.35" />
      <path
        d="M24 10v28M14 20h20"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="24" cy="24" r="4" fill="currentColor" opacity="0.2" />
      <path
        d="M32 14c2 4 2 8 0 12M16 14c-2 4-2 8 0 12"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        opacity="0.5"
      />
    </svg>
  );
}
